import { RootState } from "../../../app/rootReducer";

export const selectVisitorManagementEnabled = (state: RootState): boolean =>
  state.login.userInformation?.visitorManagementEnabled ?? false;
